<template>
  <div class="content" style="height: 100%;">
    <div>
      <div class="news-detail">
        <div class="content" v-html="content"></div>
      </div>
    </div>
    <div class="card">
      <van-form @submit="submitForm">
        <div class="form_list">
          <div class="container" style="position:relative">
            <van-field
                v-model="ruleForm.name"
                label="姓名"
                placeholder="请输入姓名"
                input-align="right"
                :rules="[{ required: true }]"
            >
              <div slot="left-icon"><van-icon :name="image_name" /></div>
            </van-field>
          </div>

           <div v-if="!isEmployee" class="container" style="position:relative">

                     <van-field
                         readonly
                         clickable
                         :value="ruleForm.address"
                         label="省市"
                         placeholder="请选择省市"
                         input-align="right"
                         right-icon="arrow"
                         :rules="[{ required: true }]"
                         @click="showProvincePicker = true"
                     >
                       <div slot="left-icon"><van-icon :name="image_address" /></div>
                     </van-field>
                   </div>
                   <div class="container" style="position:relative">
                     <van-popup v-model="showProvincePicker" position="bottom">
                       <van-area
                           title="医院"
                           :area-list="areaList"
                           :columns-num="2"
                           @confirm="getProvince"
                           @cancel="showProvincePicker = false"
                       />
                     </van-popup>
                   </div>
                   <div class="container" style="position:relative">

                     <van-field
                         v-model="ruleForm.remark"
                         label="医院"
                         placeholder="请输入医院"
                         input-align="right"
                         @input="queryHospitalAccordingTokeyword"
                         @click="queryHospitalAccordingTokeyword(ruleForm.remark)"
                         :rules="[{ required: true }]"
                     >
                       <div slot="left-icon"><van-icon :name="image_hospital" /></div>
                     </van-field>
                   </div>

                   <div
                       v-if="showHospitalPickerByKeyword"
                       class="hospitalListByKeyword"
                       style="position: absolute;z-index: 200;max-height: 200px;overflow-y: scroll;"
                   >
                     <van-cell
                         style="background-color: #eee;"
                         icon="hotel-o"
                         v-for="(item, index) in hospitalListByKeyword"
                         :key="index"
                         :value="item"
                         @click="getHospitalByKeyword(item)"
                     >
                      <template #right-icon>
                        <van-icon name="search" class="search-icon" style="margin-top: 5px;" />
                      </template>
                     </van-cell>
                   </div>

          <div v-if="!isEmployee" class="container" style="position:relative">
            <van-field
                readonly
                clickable
                :value="ruleForm.department"
                label="科室"
                placeholder="请选择科室"
                input-align="right"
                right-icon="arrow"
                :rules="[{ required: true }]"
                @click="showDepartmentPicker = true"
            >
              <div slot="left-icon"><van-icon :name="image_department" /></div>
            </van-field>
          </div>

          <van-popup v-model="showDepartmentPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="departmentList"
                value-key="value"
                @confirm="getDepartment"
                @cancel="showDepartmentPicker = false"
            />
          </van-popup>

          <div v-if="!isEmployee" class="container" style="position:relative">
            <van-field label="类别" name="category" class="category-filed" :rules="[{ required: false }]">
              <div slot="left-icon"><van-icon :name="image_hospital" /></div>
              <template #input>
                <van-radio-group v-model="ruleForm.category" direction="horizontal" @change="onChangeCategory">
                  <van-radio v-for="(item,index) in categoryList" :name="item.value" :key="index">{{item.value}}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>

          <van-popup v-model="showCategoryPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="categoryList"
                value-key="value"
                @confirm="getCategory"
                @cancel="showCategoryPicker = false"
            />
          </van-popup>

          <div v-if="ruleForm.category&&!isEmployee" class="container" style="position:relative">

            <van-field
                readonly
                clickable
                :value="ruleForm.title"
                label="职称"
                placeholder="请选择职称"
                input-align="right"
                right-icon="arrow"
                :rules="[{ required: false }]"
                @click="showTitlePicker = true"
            >
              <div slot="left-icon"><van-icon :name="image_hospital" /></div>
            </van-field>
          </div>

          <van-popup v-model="showTitlePicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="titleList"
                value-key="value"
                @confirm="getTitle"
                @cancel="showTitlePicker = false"
            />
          </van-popup>
        </div>
        <div class="container" style="position:relative">
          <van-field
              v-model="ruleForm.phone"
              label="手机号"
              type="number"
              :border="false"
              placeholder="请输入手机号"
              input-align="right"
              :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_phone" /></div>
          </van-field>
        </div>

        <div class="container" style="position:relative">
          <van-field
              v-model="ruleForm.vcode"
              label="验证码"
              type="number"
              placeholder="请输入验证码"
              input-align="right"
              :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_vcode" /></div>
            <template #button>
              <van-tag v-show="show1" type="primary" @click="sendVcode" size="medium" class="phone-btn">发送验证码</van-tag>
              <van-tag v-show="!show1" disabled type="primary" size="medium" class="phone-btn">{{count}} s</van-tag>
            </template>
          </van-field>
        </div>

        <div class="typing-box">
          <typing-first id="first" ref="first" @getResultA='getPercent' />
          <typing-first-b id="firstB" ref="first-b" v-if="isShow" @getFirstB="getFirstB" />
          <typing-second id="second" ref="second" v-if="isShow" @getAnswerSencond="getAnswerSencond"/>
          <typing-third id="third" ref="third" @getAnswerThird="getAnswerThird" :num="isShow ? 4 : 2" />
          <typing-fourth id="fourth" ref="fourth" v-if="answerThird > 0" @getAnswerFourth="getAnswerFourth" :num="isShow ? 5 : 3" />
        </div>

        <van-button class="button" color="#8259E1" block native-type="submit" >注册并提交问卷</van-button>
      </van-form>
      <van-dialog v-model="show" title="提示" show-cancel-button confirm-button-text='是' cancel-button-text='否' @confirm="confirm1">
        <div style="margin:20px">确定不使用食物回避（包括母亲饮食回避）进行诊断？</div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import API from "@/api/common";
import image_name from "@/assets/images/name.png";
import image_phone from "@/assets/images/phone.png";
import image_vcode from "@/assets/images/vcode.png";
import image_address from "@/assets/images/addicon.png";
import image_hospital from "@/assets/images/hospital.png";
import image_department from "@/assets/images/department.png";
import typingFirst from "./components/question/typingFirst";
import typingFirstB from "./components/question/typingFirstB";
import typingSecond from "./components/question/typingSecond";
import typingThird from "./components/question/typingThird";
import typingFourth from "./components/question/typingFourth";
export default {
  components: {
    typingFirst,
    typingFirstB,
    typingSecond,
    typingThird,
    typingFourth
  },
  data() {
    return {
      content: '<p>尊敬的老师：</p><p>您好！为了更好的了解<strong>食物过敏临床诊疗情况</strong>，提供更专业的服务，惠及更多食物过敏患儿，希望能够占用您约5分钟时间，协助完成以下问卷。该问卷<strong>所有问答仅用于统计分析，答案没有对错，请根据您的临床实际情况放心填写！</strong></p><p>非常感谢您的支持！</p>',
      form: {
        total: 0,
      },
      openid: this.$route.query.openid,
      skip: '1',
      name: 'first',
      show: false,
      isShow: false,
      isFourthShow: false,
      isSecondShow: false,
      answerFirstB: '',
      answerSencond: '',
      answerThird: '',
      answerFourth: '',
      show1:true,
      showExam: false,
      isEmployee: false,
      count: '',
      timer: null,
      showProvincePicker: false,
      showHospitalPicker: false,
      showDepartmentPicker: false,
      hospitalInputIsShow: false,
      showHospitalPickerByKeyword: false,
      showCategoryPicker: false,
      showTitlePicker: false,
      hospitalRequired: false,
      image_name: image_name,
      image_vcode: image_vcode,
      image_address: image_address,
      image_hospital: image_hospital,
      image_department: image_department,
      image_phone:image_phone,
      ruleForm: {
        name: "", // 姓名
        phone: "",
        vcode: "",
        province: "", // 省
        city: "", // 市
        hospital: "", // 医院
        address: "",
        remark: "", //其他医院
        category: "", //类别
        title: "", //职称
        group: "FG",
        openid: this.$route.query.openid,
        examId: this.$route.query.examId,
        unionid: this.$route.query.unionid,
        source: this.$route.query.source || 'typing'
      }, // 表单内容
      departmentList: [],
      hospitalList: [],
      hospitalListByKeyword: [],
      categoryList: [],
      titleList: [],
      cityListAll: [],
      areaJson: "",
      areaList: areaList,
      questions: [],
      coverUrl: '',
      defaultCoverUrl: require('../../assets/images/logo_ch.png'),
      remark: ''
    };
  },
  created() {
    this.getDepartmentList();
    this.getCategoryList();
    if (this.ruleForm.examId && this.ruleForm.examId !== 'null') {
      this.showExam = true
      this.findExam(this.ruleForm.examId)
    }
    this.$nextTick(()=>{
      this.isShow = this.$refs.first.answerObj.answers[3].checked;
    })
  },
  methods: {
    confirm1() {
      this.skip = '2'
      this.show  = false
      this.createCustomerInfo();
    },
    getPercent(e) {
      this.isShow = e.includes(4) ? true : false;
    },
    getFirstB(e) {
      this.isSecondShow = true;
    },
    getAnswerSencond(e) {
      this.answerSencond = e
    },
    getThirdPercent(e) {
      this.isFourthShow = e
    },
    getAnswerThird(e) {
      this.answerThird = e
    },
    getAnswerFourth(e) {
      this.answerFourth = e
    },
    toTyping(value) {
      document.querySelector(value).scrollIntoView({
        behavior: "smooth"
      });
      if (value == '#first') {
        this.$refs.first.confirm = 'confirm'
      } else if (value == '#firstB') {
        this.$refs['first-b'].confirm = 'confirm'
      } else if (value == '#second') {
        this.$refs.second.confirm = 'confirm'
      } else if (value == '#third') {
        this.$refs.third.confirm = 'confirm'
      } else if (value == '#fourth') {
        this.$refs.fourth.confirm = 'confirm'
      }
    },

    onChangeCategory(value){
      this.getTitleList(value);
    },
    getHospitalList() {
      if (this.ruleForm.city === "") {
        this.$message.error("请先选择省市！");
        return;
      }
      API.searchHospitalByCity(this.ruleForm.city).then((data) => {
        if (data && data.data.length > 0) {
          this.hospitalList = [];

          data.data.forEach((element) => {
            this.hospitalList.push({
              value: element.hosName,
            });
          });

          this.ruleForm.hospital = this.hospitalList[0].value;

          this.hospitalList.push({
            value: "其他",
          });
          this.hospitalRequired = true;
          this.showHospitalPicker = true;
        } else {
          this.hospitalRequired = false;
          this.hospitalInputIsShow = true;
        }
      });
    },
    showHospitalToInput() {
      if (this.ruleForm.city === "") {
        this.$message.error("请先选择省市！");
        return;
      }
    },
    queryHospitalAccordingTokeyword(keyword) {
      // 这里是根据keyword关键字查询接口
      if (!keyword) {
        this.showHospitalPickerByKeyword = false
        this.isEmployee = false
        return
      }
      else if (keyword === '纽迪希亚') {
        this.isEmployee = true
        return
      } else {
        this.isEmployee = false
        API.searchHospitalBykeyword(keyword, this.ruleForm.city).then((data) => {
          this.hospitalListByKeyword = [];
          if (data && data.data.length > 0) {
            // 查到相关的医院，保存接口返回的数组，并打开弹窗

            data.data.forEach((element) => {
              this.hospitalListByKeyword.push(element.hosName);
            });
            console.info(this.hospitalListByKeyword[0]);
            this.showHospitalPicker = false;
            if (this.hospitalListByKeyword.length == 1 && keyword == this.hospitalListByKeyword[0]) {
              this.showHospitalPickerByKeyword = false;
            } else {
              this.showHospitalPickerByKeyword = true;
            }
          } else {
            // 没有查到相关的医院
          }
        });
      }

    },
    queryCategoryAccordingTokeyword(keyword) {
      // 这里是根据keyword关键字查询接口
      if (!keyword) {
        this.showHospitalPickerByKeyword = false
        this.isEmployee = false
        return
      }
      else if (keyword === '纽迪希亚') {
        this.isEmployee = true
        return
      } else {
        this.isEmployee = false
        API.searchHospitalBykeyword(keyword, this.ruleForm.city).then((data) => {
          this.hospitalListByKeyword = [];
          if (data && data.data.length > 0) {
            // 查到相关的医院，保存接口返回的数组，并打开弹窗

            data.data.forEach((element) => {
              this.hospitalListByKeyword.push(element.hosName);
            });
            console.info(this.hospitalListByKeyword[0]);
            this.showHospitalPicker = false;
            this.showHospitalPickerByKeyword = true;
          } else {
            // 没有查到相关的医院
          }
        });
      }

    },
    getDepartmentList() {
      API.getDepartmentList().then((data) => {
        if (data && data.data.length > 0) {
          this.departmentList = [];
          data.data.forEach((element) => {
            this.departmentList.push({
              value: element.department,
            });
          });
        }
      });
    },
    getCategoryList() {
      API.findDictByCategory('customer_category').then((data) => {
        if (data && data.data.length > 0) {
          this.categoryList = [];
          data.data.forEach((element) => {
            this.categoryList.push({
              value: element.value,
            });
          });
        }
      });
    },
    getTitleList(category) {
      API.findDictByCategory(category).then((data) => {
        if (data && data.data.length > 0) {
          this.titleList = [];
          data.data.forEach((element) => {
            this.titleList.push({
              value: element.value,
            });
          });
        }
      });
    },

    createCustomerInfo() {
      console.info(this.ruleForm);
      const param = {tbName: this.ruleForm.name, province: this.ruleForm.province, city: this.ruleForm.city, vcode: this.ruleForm.vcode,
        tbMobile: this.ruleForm.phone, hosName: this.ruleForm.remark, department: this.ruleForm.department, openid: this.ruleForm.openid, tbGroup: 'CMA',category: this.ruleForm.category,title: this.ruleForm.title }
      API.createCustomerInfo(param).then((data) => {
        if (data.success) {
            this.submitExam()
          this.$router.push({
            name: "submitTypingSuccess",
            query: { openid: this.ruleForm.openid,  examId: this.ruleForm.examId, source: this.ruleForm.source },
          });
        } else {
          this.$message.error(data.message);
        }

      });
    },
    // 新增医生主数据
    submitForm() {
      let firstFlag = false;
      this.$refs.first.answerObj.answers.map(item => {
        if (item.checked) {
          firstFlag = true;
        }
      })
      if (firstFlag) {
        if (this.isShow) {
          if (this.$refs['first-b'].answerObj.value !== '') {
            if (this.$refs.second.answerObj.value !== '') {
              // this.createCustomerInfo();
              if (this.$refs.third.answerObj.value !== '') {
                if (this.$refs.third.answerObj.value > 0) {
                  this.getFourthValue()
                  if (this.$refs['fourth'].answerObj.remark) {
                    this.createCustomerInfo();
                  } else {
                    this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                  }
                } else {
                  this.createCustomerInfo();
                }
              } else {
                this.$message.error(`第${this.isShow?'四':'二'}题必选！`)
              }
            } else {
              this.$message.error('第三题必选！')
            }
          } else {
            this.$message.error('第二题必选！')
          }
        } else {
          if (this.$refs.third.answerObj.value !== '') {
              if (this.$refs.third.answerObj.value > 0) {
                this.getFourthValue()
                //判断第五题有没有填
                if (this.$refs['fourth'].answerObj.remark) {
                  this.createCustomerInfo();
                } else {
                  this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                }
              } else {
                this.createCustomerInfo();
              }
            } else {
              this.$message.error('第二题必选！')
            }
        }
       
      } else {
        this.$message.error('第一题必选！')
      }
    },
    getProvince(value) {
      this.ruleForm.address = value[0].name + "-" + value[1].name;
      this.ruleForm.province = value[0].name;
      this.ruleForm.city = value[1].name;
      this.ruleForm.hospital = "";
      this.ruleForm.remark = "";
      this.hospitalList = [];
      this.hospitalListByKeyword = [];
      this.showProvincePicker = false;
      this.hospitalInputIsShow = true;
      this.hospitalRequired = true;
    },
    getHospital(value) {
      this.ruleForm.hospital = value.value;
      this.showHospitalPicker = false;
    },
    getHospitalByKeyword(value) {
      console.info(value);
      this.ruleForm.remark = value;
      this.showHospitalPickerByKeyword = false;
    },
    getCategory(value) {
      console.info(value);
      if (this.ruleForm.category !== value.value) {
        this.ruleForm.category = value.value;
        this.ruleForm.title = '';
      }
      this.showCategoryPicker = false;
      this.getTitleList(value.value);
    },
    getTitle(value) {
      console.info(value);
      this.ruleForm.title = value.value;
      this.showTitlePicker = false;
    },
    getDepartment(value) {
      this.ruleForm.department = value.value;
      this.showDepartmentPicker = false;
    },
    sendVcode(phone) {
      if(!this.ruleForm.phone){
        this.$message.error("请输入手机号!");
        return
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show1 = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show1 = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
      API.sendVcode(this.ruleForm.phone).then((data) => {
        this.$message.success("发送成功!");
      });
    },
    findExam(examId) {
      API.findExam(examId).then(result => {
        this.questions = result.data.questionList
        this.questions.forEach( item => {
          if (item.type == 'RADIO') {
            item.answer = ''
          } else if (item.type == 'CHECKBOX') {
            item.answer = []
          }
        })
      })
    },
    valid() {
      let valid = true
      this.questions.forEach( item => {
        if (item.type == 'RADIO' && !item.answer) {
          valid = false
        } else if (item.type == 'CHECKBOX' && !item.answer.length > 0) {
          valid = false
        } else if (item.type == 'TEXT' && !item.answer) {
          valid = false
        }
      })
      return valid
    },
    getFirstBValue() {
      let firstB = this.$refs['first-b'].answerObj;
      console.log(firstB.remark)
      if (firstB.remark == '建议回避2-6周时进行随诊') {
          firstB.value = '1'
      } else if (firstB.remark == '建议至少回避6周以后（如2个月、3个月）再进行随诊') {
          firstB.value = '2'
      } else if (firstB.remark == '没有明确时间，患儿如果有需要可以来复诊') {
          firstB.value = '3'
      }
    },
    getFourthValue() {
      let fourth = this.$refs.fourth.answerObj;
      console.log(fourth.remark)
      if (fourth.remark == 'A、1~2个月') {
          fourth.value = '1'
      } else if (fourth.remark == 'B、3~4个月') {
          fourth.value = '2'
      } else if (fourth.remark == 'C、5~6个月') {
          fourth.value = '3'
      } else if (fourth.remark == 'D、6个月及以上') {
          fourth.value = '4'
      } 
    },
    submitExam() {
      if(this.skip==2){
        let first = this.$refs.first;
        let params = {
          openid: this.openid,
          examId: 'typingExam',
          meetingId: this.ruleForm.source,
          tbGroup: 'CMA',
          typingList: [
            first.answerObj, this.$refs.third.answerObj]
        }
        this.saveResult(params)
      } else {
          // this.getFirstBValue()
        if (this.isShow) {
          if (this.$refs['first-b'].answerObj.value !== '') {
            if (this.$refs.second.answerObj.value !== '') {
              if (this.$refs.third.answerObj.value !== '') {
                if (this.$refs.third.answerObj.value > 0) {
                  this.getFourthValue()
                  if (this.$refs['fourth'].answerObj.remark) {
                    let params = {
                      openid: this.openid,
                      examId: 'typingExam',
                      meetingId: this.ruleForm.source,
                        typingList: [
                          this.$refs.first.answerObj,
                          this.$refs['first-b'].answerObj,
                          this.$refs.second.answerObj,
                          this.$refs.third.answerObj,
                          this.$refs.fourth.answerObj]
                    }
                    this.saveResult(params)
                  } else {
                    this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                  }
                } else {
                  let params = {
                    openid: this.openid,
                    examId: 'typingExam',
                    meetingId: this.ruleForm.source,
                      typingList: [
                        this.$refs.first.answerObj,
                        this.$refs['first-b'].answerObj,
                        this.$refs.second.answerObj,
                        this.$refs.third.answerObj]
                  }
                  this.saveResult(params)
                }
              } else {
                this.$message.error(`第${this.isShow?'四':'二'}题必选！`)
              }
            } else {
              this.$message.error('第三题必选！')
            }
          } else {
            this.$message.error('第二题必选！')
          }
        } else {
          if (this.$refs.third.answerObj.value !== '') {
              if (this.$refs.third.answerObj.value > 0) {
                this.getFourthValue()
                //判断第五题有没有填
                if (this.$refs['fourth'].answerObj.remark) {
                  let params = {
                    openid: this.openid,
                    examId: 'typingExam',
                    meetingId: this.ruleForm.source,
                    typingList: [
                      this.$refs.first.answerObj,
                      this.$refs.third.answerObj,
                      this.$refs.fourth.answerObj]
                  }
                  this.saveResult(params)
                } else {
                  this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                }
              } else {
                let params = {
                  openid: this.openid,
                  examId: 'typingExam',
                  meetingId: this.ruleForm.source,
                  typingList: [
                    this.$refs.first.answerObj,
                    this.$refs.third.answerObj]
                }
                this.saveResult(params)
              }
            } else {
              this.$message.error('第二题必选！')
            }
        }
      }
    },
    checkConfirm() {
      let form = this.$refs.confirm.form
      if (form.confirm1 == 1 && form.confirm4 == 1 && 
        ((this.isShow && form.confirm2 == 1) || !this.isShow) && 
        ((this.isSecondShow && form.confirm3 == 1) || !this.isSecondShow) && 
        ((this.isFourthShow && form.confirm5 == 1) || !this.isFourthShow)
      ) {
        return true
      }
      return false
    },
    saveResult(params) {
      // if (this.checkConfirm) {
        API.saveResult(params).then(data => {
          if (data.success) {
            this.$router.push({
              name: 'submitTypingSuccess',
              query: { openid: this.openid,  examId: 'typingExam', source: this.ruleForm.source}
            });
          } else {
            this.$message.error(data.message)
          }
        })
      // } else {
      //   this.$message.error(`分型题目再次确认全部选择是才可以提交！`)
      // }
    },
  },
};
</script>
<style lang="less">
  strong {
    color: purple;
  }
</style>
<style lang="less" scoped>
.content {
  .banner {
    width: 100%;
    height: auto;
  }
  .container{
    margin:8px 0;
  }
  .icon {
    position: absolute;
    left: 15px;
    z-index: 10;
    top:-3px;
  }
  .phone {
    width: 74%;
    float: left;
  }
  .button {
    width: 90%;
    margin: 25px auto;
    border-radius: 6px;
  }
  .phone-btn {
    // min-width: 21%;
    vertical-align: middle;
  }
  .card {
    position: relative;
    width: 90%;
    height: 100%;
    margin: 0 auto;
    // background-color: #fff;
    border-radius: 6px;

    .title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      margin: 20px auto;
      color: #646566;
    }

    .hospitalListByKeyword {
      width: 100%;
      height: auto;
      margin: 0 auto;
      background-color: #fff;
    }
    .form_list {
      background-color: #fff;
    }
  }
  /deep/.van-cell-group{
    .question{
      font-size: 14px;
      // border-bottom: 1px solid #eee;
      padding: 5px 0;
    }
    .van-radio{
      margin:8px 0;
      font-size: 14px;
    }
    .van-checkbox__label{
      margin:8px;
      font-size: 14px;
    }
    margin:10px 0px;
    padding: 10px;
    border-radius: 5px;
    color: #646566;
  }
  .news-detail {
    height: 100%;
    // margin-top: 20px;
    padding-bottom: 10px;
    overflow: auto;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      text-align: center;
      color: #646566;
    }
    .examType {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      color: #646566;
    }
    .content {
      margin: 5px 10px;
      font-size: 15px;
      color: black;
    }
  }
}
</style>
<style lang="less">
.content {
  .van-field__label {
    margin-left: 6px;
  }

  .van-icon__image {
    width: 18px;
    height: 18px;
  }
  .van-radio__label {
    color: #646566;
  }
  .category-filed {
    .van-field__label {
      width: 3em;
    }
    .van-field__value {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
